var site = site || {};

site.translations = site.translations || {};
site.translations.elc_general = site.translations.elc_general || {};

(function ($, site) {
  Drupal.behaviors.shoppableVideoBlockV2 = {
    attached: false,
    attach: function (context) {
      var self = this;
      var $formatter = $('.js-shoppable-video-block-v2', context);

      if (self.attached) {
        return;
      }
      self.attached = true;

      $formatter.each(function () {
        var $thisFormatter = $(this);
        var $html = $('html');
        var $ctaProdCard = $('.js-cta-prod-card', $thisFormatter);
        var $prodCardWrapper = $('.js-shoppable-video-product-card', $thisFormatter);
        if ($prodCardWrapper.length <= 0) {
          return;
        }
        var $prodCardOverlay = $('.js-shoppable-video-product-card-overlay', $thisFormatter);
        var $prodCardCloseBtn = $('.js-shoppable-video-product-card-close', $thisFormatter);
        var $carousel = $thisFormatter.find('.js-content-block__product-grid');
        var $productBriefs = $carousel.find('.js-product-brief-v3');
        var $sizedOverlay = $('.js-product-brief__sized-overlay', $productBriefs);
        var $sizedOverlayTrigger = $('.js-product-brief__sized-overlay-trigger', $productBriefs);
        var $sizedOverlayCloseCta = $('.js-product-brief__sized-overlay-close', $sizedOverlay);
        var $sizedOverlayCartCta = $('.js-product-cta, .js-notify-me-alert', $sizedOverlay);
        var carouselDataset = $prodCardWrapper.data() || null;
        var slickSlide = '.js-product-grid';
        var $arrowsDiv = $thisFormatter.find('.js-carousel-controls');
        var $dotsDiv = $thisFormatter.find('.js-carousel-dots');
        var autoplay = carouselDataset.slidesAutoplay || false;
        var slidesToShow = carouselDataset.slidesToShow || 4;
        var slidesToScroll = carouselDataset.slidesToScroll || 1;
        var speed = carouselDataset.slidesSpeed || 300;
        var fade = carouselDataset.slidesFade ? true : false;
        var pcDotsArrowsArgs = self.checkDotsAndArrows(carouselDataset.dotsArrowsPc);
        var settingsResponsive = {
          appendArrows: $arrowsDiv,
          slide: slickSlide,
          fade: fade,
          speed: speed,
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToScroll,
          autoplay: autoplay,
          infinite: false,
          cssEase: 'cubic-bezier(.66, 0, .33, 1)',
          dots: pcDotsArrowsArgs.dots,
          arrows: pcDotsArrowsArgs.arrows,
          appendDots: $dotsDiv,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                settings: 'unslick'
              }
            }
          ]
        };

        $carousel.not('.slick-initialized').slick(settingsResponsive);

        $ctaProdCard.once().on('click', function (e) {
          var hasOpenProdCard = $thisFormatter.hasClass('product-cart-open');
          var $prdGridItem = $thisFormatter.find('.js-mpp-grid-item');
          e.preventDefault();
          $thisFormatter.toggleClass('product-cart-open', !hasOpenProdCard);
          $html.toggleClass('video-content-product-cart-open', !hasOpenProdCard);
          $prodCardWrapper.attr('aria-checked', !hasOpenProdCard);
          $prdGridItem.each(function () {
            var $this = $(this);
            var $swatchList = $('.js-product-brief-shades__grid', $this);
            if (!hasOpenProdCard) {
              $(document).trigger('product.shadeCarousel.visible', { swatchList: $swatchList });
            }
            $thisFormatter.find('.carousel-dots li.slick-active button').trigger('click');
          });
        });
        $prodCardOverlay.once().on('click', function (e) {
          e.preventDefault();
          closePrdCard();
        });
        $prodCardCloseBtn
          .once()
          .on('click', function (e) {
            e.preventDefault();
            closePrdCard();
          })
          .on('keydown', function (event) {
            if (event.key === 'Enter') {
              if (!$html.hasClass('video-content-product-cart-open')) {
                return;
              }
              closePrdCard();
            }
          });

        if ($sizedOverlayTrigger.length > 0 && $sizedOverlay.length > 0) {
          $sizedOverlayCloseCta.once().on('click', function (event) {
            event.preventDefault();
            $thisFormatter.toggleClass('product-cart-open', !hasOpenProdCard);
            $html.toggleClass('video-content-product-cart-open', !hasOpenProdCard);
            $prodCardWrapper.attr('aria-checked', !hasOpenProdCard);
          });
          $sizedOverlayCartCta.once().on('click', function () {
            $thisFormatter.toggleClass('product-cart-open', !hasOpenProdCard);
            $html.toggleClass('video-content-product-cart-open', !hasOpenProdCard);
            $prodCardWrapper.attr('aria-checked', !hasOpenProdCard);
          });
        }

        function closePrdCard() {
          $html.removeClass('video-content-product-cart-open');
          $thisFormatter.removeClass('product-cart-open');
          $prodCardWrapper.attr('aria-checked', false);
        }
      });
    },
    checkDotsAndArrows: function (dotsAndArrows) {
      var dotsArrowsArgs = {};

      switch (dotsAndArrows) {
        case 'arrows':
          dotsArrowsArgs.dots = false;
          dotsArrowsArgs.arrows = true;
          break;
        case 'dots':
          dotsArrowsArgs.dots = true;
          dotsArrowsArgs.arrows = false;
          break;
        case 'both':
          dotsArrowsArgs.dots = true;
          dotsArrowsArgs.arrows = true;
          break;
        case 'none':
          dotsArrowsArgs.dots = false;
          dotsArrowsArgs.arrows = false;
          break;
      }

      return dotsArrowsArgs;
    }
  };
})(jQuery, window.site || {});
